import styled from 'styled-components';

import { baseLinkCss } from './styled';
import { HoverTheme, IHover } from './types';

export const AddNewCardLink = styled.button<IHover>`
  ${baseLinkCss}
  text-align: center;
  padding: 0;
  color: ${p => (p.hoverTheme === HoverTheme.DARK ? Styles.color.white : Styles.color.secondary)};
  font-size: 1rem;
  font-family: ${Styles.fontFamily.base};

  &:hover {
    background-color: #a5031d;
    color: ${p => (p.hoverTheme === HoverTheme.DARK ? 'inherit' : Styles.color.white)};
  }
`;
